import { CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import type { ReactNode } from 'react';

export type StepState = 'done' | 'warn' | 'todo';

/** A numbered step of the month close, with its state at a glance. */
export function Step({
  n,
  title,
  state,
  summary,
  children,
}: {
  n: number;
  title: string;
  state: StepState;
  summary?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className={`card step step-${state}`}>
      <header className="step-head">
        <span className="step-number">{n}</span>
        <h2>{title}</h2>
        {state === 'done' && <CheckCircleFilled className="step-icon" />}
        {state === 'warn' && <ExclamationCircleFilled className="step-icon" />}
      </header>
      {summary && <div className="step-summary">{summary}</div>}
      {children}
    </section>
  );
}
